import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { provideTranslocoScope, TranslocoService } from '@jsverse/transloco';
import { forkJoin } from 'rxjs';
import { startWith, switchMap, take } from 'rxjs/operators';

const TICKER_START = new Date('2026-10-28T00:00:00-03:00');
const TICKER_END = new Date('2026-11-30T23:59:59.999-03:00');
const REPEAT_COUNT = 6;

const PHRASE_KEYS = [
    'campaignTicker.unmissable',
    'campaignTicker.limitedTime',
    'campaignTicker.seeTerms',
    'campaignTicker.blackFriday',
] as const;

function isCampaignTickerLive(now = Date.now()): boolean {
    return now >= TICKER_START.getTime() && now <= TICKER_END.getTime();
}

@Component({
    selector: 'app-campaign-ticker',
    standalone: true,
    imports: [CommonModule],
    providers: [...provideTranslocoScope('shared')],
    templateUrl: './campaign-ticker.component.html',
    styleUrl: './campaign-ticker.component.scss',
})
export class CampaignTickerComponent implements OnInit {
    readonly isLive = isCampaignTickerLive();
    readonly repeatIndexes = Array.from({ length: REPEAT_COUNT }, (_, index) => index);

    phrases: string[] = [];
    ariaLabel = '';

    constructor(
        private transloco: TranslocoService,
        private destroyRef: DestroyRef,
    ) {}

    ngOnInit(): void {
        if (!this.isLive) {
            return;
        }

        this.transloco.langChanges$
            .pipe(
                startWith(this.transloco.getActiveLang()),
                switchMap((lang) => {
                    const scopeLang = `shared/${lang}`;
                    return forkJoin(
                        PHRASE_KEYS.map((key) =>
                            this.transloco.selectTranslate<string>(key, {}, scopeLang).pipe(take(1)),
                        ),
                    );
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe((phrases) => {
                this.phrases = phrases;
                this.ariaLabel = phrases.join(' · ');
            });
    }
}
